import React, { useState, useEffect } from "react";
import {
  OutlinedInput,
  MenuItem,
  FormControl,
  ListItemText,
  Select,
  Checkbox,
  Box,
  InputAdornment,
  IconButton,
  TextField,
  ListSubheader,
  InputLabel
} from "@mui/material";
import CancelIcon from "@mui/icons-material/Cancel";
import CloseIcon from "@mui/icons-material/Close";
import SearchIcon from "@mui/icons-material/Search";
import { useDispatch } from "react-redux";
import { setState } from "./editScenarioNewSlice";
import InfiniteScroll from "react-infinite-scroller";
 
const MultiSelectNewSKU = (props) => {
  const dispatch = useDispatch();
  const columnData = props?.getSKUData;
  const refSKU = props?.reference;
  const refSKUData = columnData.filter((item) => item.id === refSKU.includes(item.id));
  const reference = [
    ...new Set(
        refSKU
        .map((item) => item.name)
        .filter((data) => data != "Select SKU")
    ),
  ];
  const columns = [
    ...new Set(
      columnData
        .map((item) => item.name)
        .filter((data) => data != "Select SKU")
    ),
  ];
 
  const [columnName, setcolumnName] = useState([]);
  const [displayItem, setDisplayItem] = React.useState(columns.length);
  const [searchText, setSearchText] = React.useState("");
  const [namesData, setNamesData] = React.useState([]);
  const textInput = React.useRef(null);
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
 
  const itemsPerPage = 200;
  const [hasMore, setHasMore] = useState(true);
  const [records, setrecords] = useState(itemsPerPage);
 
  const loadMore = () => {
    if (records === columns.length) {
      setHasMore(false);
    } else {
      setTimeout(() => {
        setrecords(records + itemsPerPage);
      }, 2000);
    }
  };
 
  const handleChange = (e, name) => {
    let items = [...columnName];
 
    if (e.target.checked) items.push(name);
    else {
      var index = items.indexOf(name);
      items.splice(index, 1);
    }
 
    setcolumnName(items);
    let data = columnData.filter((x) => items.includes(x.name));
    dispatch(setState("selectedReferenceSKU", data));
 
    let itemcount = items.length;
    setDisplayItem(itemcount);
    if (itemcount == 0) setSelectAll(false);
    if (itemcount == columns.length) setSelectAll(true);
    else setSelectAll(false);
  };
 
  useEffect(() => {
    // Clear search text value
    setNamesData(columns);
    setSelectedOptions([]);
  }, [columnData]);

  useEffect(()=>{
    const ref = [
        ...new Set(
            refSKU
            .map((item) => item.name)
            .filter((data) => data != "Select SKU")
        ),
      ];
    setcolumnName(ref);
    setDisplayItem(ref.length);
  },[refSKU])
 
  const handleDelete = (e) => {
    e.preventDefault();
    setcolumnName([]);
    dispatch(setState("selectedReferenceSKU", []));
  };
 
  const handleInputChange = (value) => {
    setSearchText(value);
  };
 
  const handleSelectAll = () => {
    if (!selectAll) {
        if(searchText){
            let val = columns.filter((name) => name.toLowerCase().includes(searchText.toLowerCase()));
            let item = [...columnName, ...val]
            const distinctArray = [...new Set(item)];
            setcolumnName(distinctArray);
            let itemcount = distinctArray.length;
            setDisplayItem(itemcount);
            let data = columnData.filter((x) => distinctArray.includes(x.name));
            dispatch(setState("selectedReferenceSKU", data));

        }else{
            setcolumnName(columns);
            let itemcount = columns.length;
            setDisplayItem(itemcount);
            let data = columnData.filter((x) => columns.includes(x.name));
            dispatch(setState("selectedReferenceSKU", data));
        }
    } else {
        if(searchText){
            let val = columns.filter((name) => name.toLowerCase().includes(searchText.toLowerCase()));
            let item = [...columnName];
            item = item.filter((name) => !val.includes(name));
            const distinctArray = [...new Set(item)];
            setcolumnName(distinctArray);
            let data = columnData.filter((x) => distinctArray.includes(x.name));
            dispatch(setState("selectedReferenceSKU", data));
            let itemcount = distinctArray.length;
            setDisplayItem(itemcount);
        }else{
            setcolumnName([]);
            dispatch(setState("selectedReferenceSKU", []));
        }
    }
    setSelectAll(!selectAll);
  };
 
//   useEffect(() => {
//     let itemcount = selectedOptions.length;
//     setDisplayItem(itemcount);
//   }, [selectedOptions]);

  useEffect(() => {
    let item = [...namesData];
    item = item.filter((name) => !columnName.includes(name));
    if(item.length == 0){
        setSelectAll(true);
    }else{
        setSelectAll(false);
    }
  }, [namesData]);
 
  useEffect(() => {
    //use a debounce to delay the search input key entry
    const delayDebounceFn = setTimeout(() => {
      if (searchText) {
        //filter options state using search text provided
        setNamesData((prevVal) => {
          let val = columns.filter((name) => name.toLowerCase().includes(searchText.toLowerCase()));
 
          return val;
        });
      } else {
        setSearchText();
        setNamesData(columns);
      }

      //set focus on search text input field on load. setTimeOut is added as textInput is not immediately available
      setTimeout(() => {
        if (textInput.current) textInput.current.focus();
      }, 100);
    }, 500);
 
    return () => clearTimeout(delayDebounceFn);
  }, [searchText]);
 
//   useEffect(() => {
//     let item = columnData.filter((x) => columnName.includes(x.name));
//     dispatch(setState("selectedReferenceSKU", item));
//   }, [columnName]);
 
  return (
    <div>
      {columns.length > 0 && (
        <InfiniteScroll
          pageStart={0}
          loadMore={loadMore}
          hasMore={hasMore}
          useWindow={false}
        >
          <FormControl>
          <InputLabel>Reference SKUs</InputLabel>
            <Select
              labelId="demo-multiple-checkbox-label"
              label="Reference SKUs"
              id="demo-multiple-checkbox"
              multiple
              sx={{
                width: "350px !important",
                height: "44px !important",
              }}
              value={columnName}
              //onChange={handleChange}
              size="small"
              input={<OutlinedInput label="Reference SKUs" />}
              renderValue={(selected) => (
                <Box
                  sx={{ display: "flex", flexWrap: "wrap", gap: 2 }}
                  MenuProps
                >
                  <div>
                    {displayItem > 1 && <span>{columnName[0].substring(0, 20)} {"..."}+ {displayItem-1}</span> }
                    {displayItem <= 1 && <span>{columnName[0].substring(0, 20)} {"..."}</span> }
                    <span>
                      <CancelIcon
                        sx={{
                          paddingLeft: "25px",
                          top: "20%",
                          position: "absolute",
                        }}
                        onMouseDown={(e) => {
                          e.stopPropagation();
                          e.preventDefault();
                        }}
                        onClick={(e) => handleDelete(e)}
                      />
                    </span>
                  </div>
                </Box>
              )}
            >
              <MenuItem onClick={handleSelectAll}>
                <Checkbox checked={selectAll} />
                <ListItemText primary="Select All" />
              </MenuItem>
              <ListSubheader>
                <TextField
                  size="small"
                  inputRef={textInput}
                  placeholder=""
                  //fullWidth
                  value={searchText}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <SearchIcon />
                      </InputAdornment>
                    ),
                    endAdornment: (
                      /*close icon to clear the search text*/
                      <InputAdornment position="end">
                        <IconButton onClick={() => setSearchText("")}>
                          <CloseIcon />
                        </IconButton>
                      </InputAdornment>
                    ),
                    autoComplete: "off" 
                  }}
                  onChange={(e) => handleInputChange(e.target.value)}
                  onKeyDown={(e) => {
                    if (e.key !== "Escape") {
                      // Prevents autoselecting item while typing (default Select behaviour)
                      e.stopPropagation();
                    }
                  }}
                />
              </ListSubheader>
              {namesData.slice(0, records).map((name, index) => (
                <MenuItem key={index + name} value={name}>
                  {selectAll ? (
                    <Checkbox
                      onChange={(e) => handleChange(e, name)}
                      checked={columnName.some((o) => o === name)}
                    />
                  ) : (
                    <Checkbox
                      onChange={(e) => handleChange(e, name)}
                      checked={columnName.indexOf(name) > -1}
                    />
                  )}
                  <ListItemText primary={name} />
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </InfiniteScroll>
      )}
    </div>
  );
};
 
export default MultiSelectNewSKU;